import React, { FC, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Wallet } from 'ethers';

import FormHeader from '../form-header/form-header';
import { DocumentIcon, KeyIcon } from 'assets/icons';
import { ReactComponent as WarningIcon } from '../../../../modules/common-icons/warning-icon.svg';
import IconBtn from '../../../../modules/icon-btn/icon-btn';
import CloseIcon from '../../../../modules/authorization/alert/icons/close-icon.svg';
import LostKeyIcon from 'assets/icons/lost-key.svg';
import SaveKeyIcon from 'assets/icons/save-key.svg';
import GiveKeyIcon from 'assets/icons/give-key.svg';
import '../../../../modules/authorization/alert/alert.scss';
import '../../../key-storage/index.scss';
import {
  downloadFile,
  getPdfFromBase64,
} from '../../../../utils/files/downloadFile';
import { setPubKey } from '../../../../store/actions/signup';
import { useAppDispatch } from '../../../../store';
import AppCheckbox from '../../../../modules/app-checkbox/app-checkbox';
import './key-generation-step.scss';
import KeyWordModal from '../../../KeyWordModal';
import { showLoader, hideLoader } from 'store/actions/loader';
import { setPush } from 'store/actions/app';

const aes256 = require('aes256');

const KeyGenerationStep: FC = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [keyWordModalOpen, setKeyWordModalOpen] = useState(false);

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isSystemWarning, setIsSystemWarning] = useState(true);
  const [storageMode, setStorageMode] = useState('');
  const [isRiskAgree, setIsRiskAgree] = useState(false);

  const onSubmitKeyWord = (key?: string) => {
    setKeyWordModalOpen(false);
    const wallet = Wallet.createRandom();
    const encryptedKey = key
      ? 'ENC(' + aes256.encrypt(key, wallet.privateKey) + ')'
      : wallet.privateKey;
    dispatch(showLoader());
    dispatch(
      setPubKey({
        pubKey: wallet.publicKey,
      })
    )
      .then(() => {
        const resultBlob = getPdfFromBase64(encryptedKey);
        downloadFile(resultBlob, 'Private.txt', 'text/plain');
        history.push('/auth/signup/key-generation-result');
      })
      .catch(() => {
        dispatch(
          setPush({
            type: 'error',
            message: 'Ошибка при установке ключа',
          })
        );
      })
      .finally(() => {
        dispatch(hideLoader());
      });
  };

  const generationKey = () => {
    setKeyWordModalOpen(true);
  };

  const onClose = () => {
    setIsSystemWarning(false);
  };

  const selectStorage = (mode: string) => {
    setStorageMode(mode);
    if (mode === 'file' || mode === 'keystore') {
      setIsButtonDisabled(false);
    }
  };

  return (
    <form className="login-form login-form--6 key-generation-step">
      <KeyWordModal
        open={keyWordModalOpen}
        onClose={() => {
          setKeyWordModalOpen(false);
        }}
        onSubmit={onSubmitKeyWord}
      />
      <FormHeader bigTitle="Генерация Ключа" />
      <div className="login-form__fildset">
        <h2 className="text-1 login-form__fildset-title ">
          Для работы на платформе необходимо сгенерировать приватный Ключ
        </h2>
        <div className="key-form__container">
          <p>Выберите способ хранения Ключа:</p>
          <br />
          <div className="key-generation-step__row">
            <div
              className={
                storageMode === 'file'
                  ? 'key-form-storage-block__selected'
                  : 'key-form-storage-block'
              }
              onClick={() => {
                selectStorage('file');
              }}
            >
              <div className="storage_block__body">
                <div className="storage_block__icon">
                  <DocumentIcon />
                </div>
                <div>
                  <h2 className="storage_block__title">Сохранить файлом</h2>
                  <p className="p p_font-size_12 p_color_grey">
                    В формате *.key
                  </p>
                </div>
              </div>
            </div>
            <br />
            <div
              className={
                storageMode === 'keystore'
                  ? 'key-form-storage-block__selected'
                  : 'key-form-storage-block'
              }
              onClick={() => {
                selectStorage('keystore');
              }}
            >
              <div className="storage_block__body">
                <div className="storage_block__icon">
                  <KeyIcon />
                </div>
                <h2 className="storage_block__title">Сохранить в KeyStore</h2>
              </div>
            </div>
          </div>
          <div className="login-form__item-input--sm">
            {isSystemWarning && (
              <div className="authorization__alert">
                <div className="attention-no">
                  <div className="attention-no__top">
                    <div className="attention-no__left">
                      <WarningIcon className="icon" />
                      <p className="text-2 attention-no__title">
                        Внимание! Рекомендации по обращению с Ключом:
                      </p>
                    </div>
                    <div className="attention-no__right">
                      <IconBtn onClick={onClose} icon={CloseIcon} />
                    </div>
                  </div>
                  <div className="attention-no__body">
                    <div className="key-generation-step__recommendation">
                      <img
                        className="key-generation-step__recommendation-icon"
                        src={LostKeyIcon}
                        alt="Не теряйте Ключ"
                      />
                      <p className="p p_font-size_12 p_color_orange p_text_center">
                        Не теряйте Ключ
                      </p>
                    </div>
                    <div className="key-generation-step__recommendation">
                      <img
                        className="key-generation-step__recommendation-icon"
                        src={SaveKeyIcon}
                        alt="Не храните Ключ в открытом виде"
                      />
                      <p className="p p_font-size_12 p_color_orange p_text_center">
                        Не храните Ключ в открытом виде
                      </p>
                    </div>
                    <div className="key-generation-step__recommendation">
                      <img
                        className="key-generation-step__recommendation-icon"
                        src={GiveKeyIcon}
                        alt="Не передавайте Ключ третьим лицам"
                      />
                      <p className="p p_font-size_12 p_color_orange p_text_center">
                        Не передавайте Ключ третьим лицам
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <br />
            <br />
            <div className="login-form__checkboxs">
              <AppCheckbox
                checked={isRiskAgree}
                sm
                onChangeValue={(value) => {
                  setIsRiskAgree(value);
                }}
                title="Я ознакомлен и принимаю риск утраты Ключа или несанкционированного доступа третьих лиц к моему Ключу, указанный в пунктах 4.4, 4.5 Декларации о рисках"
              />
            </div>
            <br />
            <br />
            <div className="login-form__footer">
              <div className="login-form__actions">
                <IconBtn
                  lg
                  title="Сгенерировать Ключ"
                  onClick={generationKey}
                  disabled={isButtonDisabled || !isRiskAgree}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default KeyGenerationStep;
